import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Tabs } from "@/core/components/ui/tabs";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralHistorySidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      direction="column"
      justify="between"
      align="start"
      className={"flex-none bg-bg-secondary/50 p-6"}
    >
      <Skeleton className="h-[30px] w-3/5"></Skeleton>
      <Stack className="flex flex-col gap-2" gap={"md"}>
        <Skeleton className="h-[28px] w-60"></Skeleton>
        <Skeleton className="h-[20px] w-40"></Skeleton>
      </Stack>
      <Skeleton className="mt-2 h-[40px] w-full"></Skeleton>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack gap="none" fullWidth className="h-full">
        <Tabs className="flex w-full flex-1 flex-col gap-4 overflow-hidden px-6">
          <Stack
            direction="row"
            justify="between"
            gap="md"
            className="border-b-[1px] py-[22px]"
          >
            <Skeleton className="h-[20px] w-full"></Skeleton>
            <Skeleton className="h-[20px] w-full"></Skeleton>
          </Stack>

          <Stack fullWidth gap="lg" className="mt-2">
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Skeleton className="h-[1px] w-full"></Skeleton>
            <Stack fullWidth gap="sm">
              <Skeleton className="h-[16px] w-20"></Skeleton>
              <Skeleton className="h-[102px] w-full"></Skeleton>
            </Stack>

            <Stack direction="row" gap="md">
              <Skeleton className="h-[40px] w-[156px]"></Skeleton>
              <Skeleton className="h-[40px] w-[104px]"></Skeleton>
            </Stack>

            <Skeleton className="h-[1px] w-full"></Skeleton>

            <Stack fullWidth gap="sm">
              <Skeleton className="h-[16px] w-[100px]"></Skeleton>
              <Skeleton className="h-[20px] w-[80px]"></Skeleton>
            </Stack>

            <Stack fullWidth gap="sm">
              <Skeleton className="h-[16px] w-[80px]"></Skeleton>
              <Skeleton className="h-[20px] w-[260px]"></Skeleton>
            </Stack>

            <Stack fullWidth gap="sm">
              <Skeleton className="h-[16px] w-20"></Skeleton>
              <Skeleton className="h-[20px] w-full"></Skeleton>
              <Skeleton className="h-[12px] w-full"></Skeleton>
            </Stack>
          </Stack>

          <Skeleton className="mt-2 h-[44px] w-full"></Skeleton>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
